import React from "react";
import { Button, CircularProgress } from "@mui/material";
import { getTreffasButtonSx } from "./treffasButtonStyles";

/**
 * Canonical Treffas button primitive.
 * @see docs/DESIGN_SYSTEM.md §8.1
 *
 * @param {object} props
 * @param {"primary"|"secondary"|"ghost"|"danger"|"dark"} [props.variant]
 * @param {"sm"|"md"|"lg"} [props.size]
 * @param {boolean} [props.loading]
 */
const TreffasButton = React.forwardRef(function TreffasButton(
  {
    variant = "primary",
    size = "md",
    loading = false,
    disabled,
    children,
    sx,
    ...props
  },
  ref
) {
  return (
    <Button
      ref={ref}
      disableElevation
      disabled={disabled || loading}
      sx={[...getTreffasButtonSx(variant, size), sx]}
      {...props}
    >
      {loading ? (
        <CircularProgress size={20} color="inherit" aria-label="Loading" />
      ) : (
        children
      )}
    </Button>
  );
});

export default TreffasButton;
